import React, { type FC } from 'react'
import { Link } from "gatsby"

interface NavLinkProps {
  to: string
  title: string
  onClick?: () => void
}

const NavLink: FC<NavLinkProps> = ({ to = "", title = "", onClick = "" }) => {

  return (
    <li>
      <Link
        onClick={onClick}
        to={to}
        title={`Go to ${title} Page`}
        className={`nav-link ${title.toLowerCase()}-link`}
        activeClassName="active">
        <span>{title}</span>
      </Link>
    </li>
  )
}

export default NavLink
